exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* **************************************************************************\n * CounterBadge\n * *************************************************************************/\n.DropdownButton__CounterBadge__UhXk3r {\n  position: absolute;\n  top: -4.2px;\n  right: -4.2px;\n  font-family: monospace;\n  width: 14px;\n  height: 14px;\n  line-height: 12px;\n  font-size: 10px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n  border-radius: 14px;\n  background: #d13f19;\n  color: #fff;\n}\n.DropdownButton__CounterBadge__UhXk3r.DropdownButton__wide__2VoEk5 {\n  width: 18px;\n}\n", ""]);

// exports
exports.locals = {
	"CounterBadge": "DropdownButton__CounterBadge__UhXk3r",
	"wide": "DropdownButton__wide__2VoEk5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/DropdownButton.styl
// module id = 3601
// module chunks = 39